import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import configureStore from './store/configureStore';
import * as RoutesModule from './routes';
import * as accountActions from './actions/accountActions';
let routes = RoutesModule.routes;

import './styles/bootstrap.min.css';
import './styles/slick.css';
import './styles/slick-theme.css';
import '../node_modules/toastr/build/toastr.min.css';
import './styles/magnific-popup.css';
import './styles/material.css';
import './styles/getmdl-select.min.css';
//import './styles/materialize-tags.min.css'; - commented 3/12/2019
//import './styles/lightGallery.css';
import './styles/offline-language-english.css';
import './styles/offline-theme-dark.css';
import './styles/cookies_eu.css';
import './styles/strength.css';
import './styles/style.css';
import './styles/rrssb.css'; //used for responsive buttons
//import './styles/bootstrap-multiselect.css'; - commented 3/12/2019
//***do we need this? */
//import './styles/daterangepicker.css'; //- commented 3/12/2019
//import './node_modules/daterangepicker/daterangepicker.css';
//import './styles/addtohomescreen.css';
//***do we need this??? we already have a few date pickers - we do */
import 'bootstrap-material-datetimepicker/css/bootstrap-material-datetimepicker.css';

import './scripts/modernizr-custom.js'; 
//import './scripts/jquery-ui-1.11.2.custom.min.js'; 
//import './scripts/jquery.magnific-popup.js'; 
import './scripts/offline.min.js'; 
//import './scripts/jquery.validate.min.js'; 
//import './scripts/jquery.validate.unobtrusive.min.js'; 
//import './scripts/jquery.unobtrusive-ajax.min.js'; 
import './scripts/jquery.jplayer.js'; 
//import './scripts/jquery-scrollto.js'; 
import './scripts/material.js'; 
//import './scripts/getmdl-select.js'; 
//import './scripts/materialize-tags.min.js'; 
import './scripts/bootstrap.min.js'; 
//import './scripts/jquery.bxslider.min.js'; //commented 3rd December
//import './scripts/lightgallery.min.js'; 
//import './scripts/placeholder.js'; 
//import './scripts/jquery.cookie.js'; 
//import './scripts/addtohomescreen.min.js'; 
//import bloodhound from 'bloodhound-js';
//import typeahead from 'typeahead'; 
//import './scripts/slimmage.js'; 
//import './scripts/slimmage.background.js'; 
import './scripts/rrssb.js'; 
//import './scripts/masonry.pkgd.min.js'; 
//import './scripts/imagesloaded.pkgd.min.js'; 
//import './scripts/classie.js'; 
//import './scripts/AnimOnScroll.js'; 
//import typed from 'typed.js'; 
//import './scripts/strength.js'; 
//import bootstrapMultiSelect from 'bootstrap-multiselect'; 
import './favicon.ico';
import AnalyticsService from './services/analyticsService.js';
import WidgetService from './services/widgetService.js';
import {loadState, saveState} from './utils/localStorage';
import BaseService from './services/baseService';
import throttle from 'lodash/throttle';
import * as accountUtils from './utils/accountUtils';
import * as types from './actions/actionTypes';
require.context("./images/ExternalPromo", true, /\.jpe?g$|\.gif$|\.png$/);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const persistedState = loadState();
const updatedState = Object.assign({}, initialState, persistedState);

const store = configureStore(history, updatedState);

store.subscribe(throttle(() => {
    //save the account details to local storage
    const account = store.getState().account;
    accountUtils.saveAccountDetails(account);
}, 1000));

if(updatedState.account.token) {
    BaseService.setToken(updatedState.account.token, updatedState.account.tokenExpiry);
    //we don't need the below until we implement refresh tokens
    //store.dispatch({ type: types.SCHEDULE_TOKEN_REFRESH, payload: { tokenExpiry: updatedState.account.tokenExpiry, refreshToken: updatedState.account.refreshToken} });
    accountActions.getUser(false, true)(store.dispatch, store.getState)
        .then(user => {
            if(!user) {
                //the token may have expired
                store.dispatch({ type: types.LOGOUT });
                BaseService.clearToken();
            }
        });
}

//delay this so it doesn't affect the page load time
window.setTimeout(() => {
    AnalyticsService.initialiseGA();
    AnalyticsService.initialiseFB();
    AnalyticsService.initialiseBing();
    //AnalyticsService.initialiseTwitter();
    AnalyticsService.initialiseHotjar();
    WidgetService.initialiseFacebook();
    WidgetService.initialiseTwitter();
}, 2000);


history.listen(function (location) {
    locationSet(location);
 });
 //log the initial location
 locationSet(history.location, true);

 function locationSet(location, initialLoad = false) {
    if(location.pathname == '/') {
        $('body').removeClass('stickyhead-sub');
    }
    else {
        $('body').addClass('stickyhead-sub');
    }
    if(initialLoad) {
        window.setTimeout(() => {
            AnalyticsService.logPageViewGA(location.pathname);
            AnalyticsService.logPageViewFB(location.pathname);
        }, 3000);
    }
    else {
        AnalyticsService.logPageViewGA(location.pathname);
        AnalyticsService.logPageViewFB(location.pathname);
    }
 }

function renderApp() {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.hydrate(
        <AppContainer>
            <Provider store={ store }>
                <ConnectedRouter history={ history } children={ routes } />
            </Provider>
        </AppContainer>,
        document.getElementById('react-app')
    );
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
    module.hot.accept('./routes', () => {
        routes = require('./routes').routes;
        renderApp();
    });
}
